module.exports = __webpack_public_path__ + "img/acm.99179e9f.jpg";